// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"7c13b981","845":"b86624d7","971":"47270105"}[chunkId] + ".chunk.js";
};